export default {
  pageTitle: '批量价格设置',
  methodPrice: '价格设置方式',
  radio1: '统一采用折扣方式',
  radio2: '统一加减价',
  radio3: '统一价',
  setting1: '设置统一采用百分比折扣',
  setting2: '设置统一加减价',
  setting3: '设置为同样价格',
  content: '仅支持设置1-99之间的整数，价格计算后将进行向下取整。比如您若想优惠20%,请输入80;比如价格计算出为23.9将会保留为23。请在价格设置完成后进行检查。',
  content2: '这里是指在销售价格上加或减一个固定值。比如-30表示当前选择的所有商品都会降价30作为促销价。闪购和每日折扣不支持加价；如果价格计算后超过正常销售价，您的申请将被系统自动拒绝。请在设置后进行检查。',
  content3: '所有选定的产品将被设置为指定的价格， 请务必小心使用此设置，设置后请记得检查价格',
  confirmAndSubmit: '确认设置并且进行提交',
  main1: '商品报名成功',
  main2: '以下商品报名失败',
  main3: 'Listing ID',
  main4: 'SkU ID',
  main5: 'Msg',
  main6: '个商品报名成功',
  error1: '输入1-99的整数',
  tips: '您确认要执行吗',
  error2: '请填写统一定价'
}
